import type { IAddress } from "@src/types/AppTypes";

export const getAddressInitialValue = <T,>(
  isEdit: boolean,
  address: IAddress | null,
  key: keyof IAddress
) => {
  if (isEdit && address) {
    return address[key] as unknown as T;
  }
  return "" as unknown as string;
};

export const isFieldEmpty = (field: string) => !field.trim();
